import styles from "./styles/link-input.module.scss";
import Loader from "@/components/common/loader";
import Image from "next/image";
import deleteIcon from "@/assets/convert/delete.svg";
import MusicPlayer from "@/components/pages/convert/components/music-player";
import StyledInput from "@/components/common/input/styled-input";
import React from "react";
import { YouTubeAudio } from "@/hooks/use-youtube-url-download";
import MediaFormatsInputPlayer from "@/components/common/music-player/media-formats-input-player";

interface LinkInput {
  isLoading: boolean;
  youtubeAudio: YouTubeAudio | null;
  handleDeleteYoutubeFile: () => void;
  musicPlayerFileUrl: string;
  songLinkValue: string;
  isLinkValid: boolean;
  handleDownload: () => void;
  handleLinkInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const LinkInput = ({
  isLoading,
  youtubeAudio,
  handleDeleteYoutubeFile,
  musicPlayerFileUrl,
  songLinkValue,
  isLinkValid,
  handleDownload,
  handleLinkInputChange,
}: LinkInput) => {
  if (isLoading) {
    return (
      <div className={styles.loader_wrapper}>
        <div className={styles.loader_container}>
          <Loader />
        </div>
        <p className={styles.loader_text}>Loading... Please wait...</p>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      {youtubeAudio && youtubeAudio.file ? (
        <>
          <div
            className={styles.bin}
            role={"presentation"}
            onClick={handleDeleteYoutubeFile}
          >
            <Image className={styles.bin_icon} src={deleteIcon} alt="delete" />
          </div>
          <MediaFormatsInputPlayer
            url={musicPlayerFileUrl}
            fileName={youtubeAudio.title}
            image={youtubeAudio.icon}
          />
        </>
      ) : (
        <>
          <StyledInput
            title="Add a YouTube link"
            value={songLinkValue}
            isValid={true}
            type="link"
            onChange={handleLinkInputChange}
            placeholder="https://www.youtube.com/"
            titleColor={"#f2f2f2"}
          />
          <button
            className={styles.upload_button}
            disabled={!isLinkValid}
            onClick={handleDownload}
          >
            CREATE
          </button>
        </>
      )}
    </div>
  );
};

export default LinkInput;
